<section class="container flex flex-col gap-6">

  <div class="list-customer-container w-full mt-1 mb-1">
    <rfc-filter class="w-full block" [filters]="filters" (discardEvent)="search($event)"
      (confirmEvent)="search($event)"></rfc-filter>
  </div>

  <div class="list-customer-container w-full">
    <div class="flex flex-col items-start gap-[20px] w-full">
      <rfc-table class="w-full block" [table]="table" [exportExcel]="true"
        (excelExport)="onExportCommercialRoleList($event)" [page]="this.searchParams?.page"
        (onClickEvent)="selectionCustomer($event)" (onPageChangeEvent)="onPageChangeEvent($event)"
        (onSortSelected)="onSortSelected($event)"></rfc-table>
    </div>
  </div>

</section>